import React, { useEffect } from "react"
import SineWaves from "sine-waves"

export default function Wave({ className }) {
  useEffect(() => {
    new SineWaves({
      el: document.getElementById("waves"),
      ...waveArgs,
      // Called on window resize
      resizeEvent: function () {
        let gradient = this.ctx.createLinearGradient(0, 0, this.width, 0)

        gradient.addColorStop(1, "rgba(255, 255, 255, 1")

        let index = -1
        let length = this.waves.length
        while (++index < length) {
          this.waves[index].strokeStyle = gradient
        }

        // Clean Up
        index = 0
        length = 0
        gradient = 0
      },
    })
  }, [])

  return <canvas id="waves" className={className} />
}

const waveArgs = {
  speed: 2,

  ease: "SineInOut",

  wavesWidth: "100%",

  waves: [
    {
      timeModifier: 4,
      lineWidth: 1,
      amplitude: -5,
      wavelength: 25,
    },
    {
      timeModifier: 2,
      lineWidth: 1,
      amplitude: -2,
      wavelength: 30,
    },
    {
      timeModifier: 1,
      lineWidth: 1,
      amplitude: -10,
      wavelength: 30,
    },
    {
      timeModifier: 3,
      lineWidth: 1,
      amplitude: 16,
      wavelength: 40,
    },
    {
      timeModifier: 0.5,
      lineWidth: 1,
      amplitude: -22,
      wavelength: 60,
    },
    {
      timeModifier: 1.3,
      lineWidth: 1,
      amplitude: -18,
      wavelength: 40,
    },
  ],
}
